export default __webpack_public_path__ + "static/media/pizza.f97959e1.svg";